export default "__VITE_ASSET__DpBa1PX$__"